/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model'];
const factory = function (Model) {
  class ExchangeRate extends Model {
    static initClass() {
      this.prototype.id = null;
      this.prototype.$resource = 'exchangeRate';
      this.prototype.$idName = 'currencyId';
    }
    $init() {}
  }
  ExchangeRate.initClass();

  return ExchangeRate;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.exchangeRate', moduleDeps)
  .factory('ExchangeRate', factory);
